import { useEffect } from 'react';
import { useRecommendationsState } from './recommendationsStore';
import useSearchParams from '../../hooks/useSearchParams';
export const useSetLastClickedRecommendationItemFromUrl = ({
  id,
  type
}) => {
  const {
    setLastClickedRecommendationItem
  } = useRecommendationsState();
  const [{
    recommendationsCorrelationId,
    recommendationsType
  }, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (recommendationsCorrelationId && recommendationsType === 'ranked' && id && type) {
      setLastClickedRecommendationItem({
        item: {
          id,
          type
        },
        correlationId: recommendationsCorrelationId,
        recommendationEngine: 'ranked'
      });
      setSearchParams({
        recommendationsCorrelationId: undefined,
        recommendationsType: undefined
      });
    }
  }, [recommendationsCorrelationId, recommendationsType, id, type, setLastClickedRecommendationItem, setSearchParams]);
};